module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column--single text--blue",
    attrs: {
      "id": "hangul-blocks"
    }
  }, _vm._l((_vm.blocks), function(block) {
    return _c('hangul-block', {
      key: block.name,
      attrs: {
        "block-name": block.name,
        "num-frames": block.numFrames
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50955aa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HangulBlocks.vue
// module id = 146
// module chunks = 0